export default function checkIfCanCreateQuestionsRoutes({ next, store }) {
  let scopes = store.getters.userScopes;
  return scopes.includes('manage_questions_create') ? next() : next({ name: 'dashboard' });
}
